import React, { useEffect, useState } from "react";
import PersonAddAlt1Icon from "@mui/icons-material/PersonAddAlt1";
import { useNavigate } from "react-router-dom";

import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
import Topbar from "../../../Component/Topbar/Topbar";
import { Table } from "../../../Component/Table/Table";
import { edit, search, view } from "../../../assets/img";
import SelectBox from "../../../Component/SelectBox";
import { get, post } from "../../redux/api/ApiHandler";
import { URLS } from "../../redux/api/Constants";
import moment from "moment";
import { couponOptions } from "../../redux/api/dummyJson";
import useSearchFunction from "../../../Component/searchFunction";
const NewTicket = () => {
  const navigate = useNavigate();

  const [list, setList] = useState([]);
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState({});
  const [selected, setSelected] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [regionOptions, setRegionOptions] = useState([]);
  const [count, setCount] = useState(0);

  const debounceval = useSearchFunction(searchValue);

  const ticketList = async (search, selected) => {
    setSearchValue(search);
    let payload = {
      search: search,
      region_id: selected?.value,
      page: page,
      type: 1,
    };
    setSelected(selected);
    let res = await post(URLS.TICKET_LIST, payload);
    if (res?.status == "success") {
      setList(res?.lists);
      setPagination(res?.pagination_meta);
    }
  };

  useEffect(() => {
    ticketList(debounceval);
    regionList();
  }, [debounceval, page]);

  const regionList = async () => {
    let res = await get(URLS.REGIONLIST);
    if (res?.status === "success" && Array.isArray(res?.roles)) {
      // 🔹 Convert API data to Select options
      const options = res?.roles.map((region) => ({
        value: region?.id,
        label: region?.name,
      }));
      setRegionOptions(options);

      // // 🔹 If you also want to preselect a region (e.g. from user profile)
      // const regionId = res?.roles?.id || null; // adjust key as per API
      // if (regionId) {
      //   const selected = options.find((opt) => opt.value === regionId);
      //   if (selected) {
      //     setRegionId(selected)
      //     // setValue("region", selected);
      //     console.log("ddd", selected);

      //   }
      // }
    }
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "S.No",
        accessor: "",
        Cell: ({ value, row }) => {
          return <p>{(page - 1) * 10 + row.index + 1}</p>;
        },
      },

      {
        Header: "Ticket ID ",
        accessor: "code",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap ">{value}</p>;
        },
      },
      {
        Header: "Region",
        accessor: "region",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap ">{value}</p>;
        },
      },
      {
        Header: "Regional Manager",
        accessor: "regional_manager",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap ">{value}</p>;
        },
      },
      {
        Header: "Service Engineer",
        accessor: "service_engineer",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap ">{value}</p>;
        },
      },

      {
        Header: "Customer ID",
        accessor: "customer.code",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap ">{value}</p>;
        },
      },
      {
        Header: "Customer Name",
        accessor: "customer",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap ">{value?.name}</p>;
        },
      },
      {
        Header: "Created by",
        accessor: "created_by",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap ">{value?.name}</p>;
        },
      },

      {
        Header: "Date",
        accessor: "opened_at",
        Cell: ({ value, row }) => {
          return (
            <p className="text-nowrap ">{moment(value).format("DD-MM-YYYY")}</p>
          );
        },
      },

      {
        Header: "Actions",
        accessor: "",
        Cell: ({ value, row }) => {
          return (
            <React.Fragment>
              <div className="d-flex ac-jc mt-2 gap-3">
                <button
                  onClick={() => {
                    navigate("/new-ticket-view", {
                      state: { type: "view", id: row?.original?.id },
                    });
                  }}
                  className="cust-btn "
                >
                  <img src={view} alt="" className=" editor-btn " />
                </button>
                {/* <button
                  onClick={() => {
                    navigate("/new-ticket-view", { state: { type: "edit", id: row?.original?.id } });
                  }}
                  className="cust-btn "
                >
                  <img src={edit} alt="" className=" editor-btn " />
                </button> */}
              </div>
            </React.Fragment>
          );
        },
      },
    ],
    []
  );
  return (
    <>
      <Topbar header={"New Ticket"} />
      <div className="container_fluit1">
        <div className="d-flex ac-js">
          <h4 className="f3 fs-sm-15 fs-md-19 fs-lg-20 fs-xl-22 fs-xxl-24">
            Total New Ticket : {pagination?.total}
          </h4>
        </div>
        <div className="d-flex ac-je gap-4">
          <div className="col-md-2">
            <SelectBox
              options={regionOptions}
              selected={selected}
              setSelected={(val) => ticketList(searchValue, val)}
            />
          </div>

          <div className="search-input col-md-3 d-flex ac-jb my-4">
            <input
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value, selected)}
              type="text"
              placeholder="Search "
              className="search-field f2 fs-sm-13 fs-md-15 fs-lg-16 fs-xl-18 fs-xxl-20"
            />
            <img src={search} className="search" />
          </div>
        </div>
        <Table
          columns={columns}
          setPageno={setPage}
          pagecount={pagination}
          data={list ?? []}
          show={true}
        />
      </div>
    </>
  );
};

export default NewTicket;
